{
  "broadly, avoid committing changes to this file": true,
  "but, it's fine if you do since deployed envs will ignore it": true,
  "signup": true,
  "triage-flag": true,
  "limbic-flag": true,
  "generalist-refactor": true,
  "healthcoach": true,
  "ai-outreach": true,
  "chat-inactivity-timeout-seconds": 60,
  "sms-replies": true,
  "log-rx-history-in-braintrust": true,
  "ai-doctor-renewals": true,
  "chai-paywall-require-entitlements": true,
  "clinical-ai-v1": true,
  "pre-async-collection": true
}
